export const VerticalDivider = () => {
  return (
    <svg
      width="2"
      height="16"
      viewBox="0 0 2 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.13708 1.2041L1.13708 14.6965"
        stroke="#B7B7B7"
        stroke-linecap="round"
      />
    </svg>
  );
};
